import React, { useState, useEffect } from 'react';
import { Link, useParams} from 'react-router-dom';
import { Alert, Heading, Stack, Box, SegmentGroup, HStack, Text, Textarea, Field,Flex, Spacer, Input, Select, createListCollection, Portal, Button, Wrap, DataList, Container, Code} from '@chakra-ui/react';
import axios from 'axios';
import { LuArrowLeft as LuBack, LuTestTube, LuTestTubes, LuFileSpreadsheet, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"
import PageContent from 'components/ui/PageContent';
import PageTitle, {titleIconSize, titleMB} from 'components/ui/PageTitle';

function SamplePage() {
  const { sampleId } = useParams(); // from URL
  const [sample, setSample] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSample = async() => {
      try {
        const response = await axios.get(`/api/sample/${sampleId}`);
        const _sample = response.data;
        //read extra_data as json:
        if (_sample.extra_data) {
          try {
            const extra_data = JSON.parse(_sample.extra_data);
            // add extra_data to sample dictionary at root level
            Object.keys(extra_data).forEach(key => {
              _sample[key] = extra_data[key];
            });

          } catch (err) {
            console.error('Error parsing extra_data', err);
          }
        }
        setSample(response.data);
        console.log("Sample data:", response.data);
      } catch (err) {
        console.error('Error fetching jobs', err);
        setError(err.message);
      }
    };

    if (sampleId) {
      fetchSample();
    }
  }, [sampleId]);

  const stats = [
    { label: "ID", value: sample.id },
    { label: "Name", value: sample.name },
    { label: "Project", value: sample.project },
    // { label: "Annotation Date", value: sample.date },
    // { label: "Ingestion Date", value: new Date(sample.ingest_date+'Z').toLocaleString() },
  ];

  const addStat = (key, label, tf=null) => {
    if (sample[key]) {
      if (tf) {
        stats.push({ label: label, value: tf(sample[key]) });
      } else {
        stats.push({ label: label, value: sample[key] });
      }
    }
  }

  addStat("date", "Annotation Date");
  addStat("organism", "Organism");
  addStat("db_type", "Nucl/Prot", (v) => {return v==="both" ? "Nucleotide and Protein" : v});
  addStat("gram", "Gram Stain");
  addStat("performed_by", "Performed By");
  // addStat("analysis_type", "Analysis");
  addStat("total_genome_size", "Genome Size");
  addStat("number_of_sequences", "Sequence Count");
  addStat("number_of_features", "Features");
  addStat("gene_density_gene_per_Mbp", "Gene Density", (v) => {return v + " genes/Mbp"});
  addStat("max_gene_size", "Max Gene Size");
  addStat("min_gene_size", "Min Gene Size");
  addStat("average_gene_size", "Avg Gene Size");
  addStat("number_of_CDS", "CDS");
  addStat("number_of_hypothetical", "Hypotheticals");
  addStat("number_of_tRNA", "tRNA");
  addStat("number_of_rRNA", "rRNA");
  addStat("with_a_RefSeq_annotation", "RefSeq");
  addStat("with_a_GO_annotation", "GO");
  addStat("with_a_COG_annotation", "COG");
  addStat("with_a_EC_annotation", "EC");
  
  const handleDownload = async () => {
    try {
      const response = await axios.get(`/api/download_sample/${sampleId}`);
      
      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = `sample_${sampleId}.gbk`; // fallback
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }
      
      // Create a downloadable link for text content
      const element = document.createElement('a');
      const file = new Blob([response.data], { type: 'text/plain' });
      element.href = URL.createObjectURL(file);
      element.download = filename;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      URL.revokeObjectURL(element.href);
      
    } catch (err) {
      console.error('Error downloading sample:', err);
      alert("Error downloading sample.");
    }
  };

  return (
    <PageContent>
      <HStack align={"center"} gap="2em">
        <Box mb={titleMB}>
          <Link to="/samples" >
            <LuBack size={titleIconSize} mb={titleMB} strokeWidth="2.5" />
          </Link>
        </Box>
        <PageTitle icon={LuTestTube} title="Sample Details" />
      </HStack>

      <DataList.Root orientation={"horizontal"} >
          {stats.map((item) => (
            <DataList.Item key={item.label}>
              <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
              <DataList.ItemValue>
                <Container px="0">
                  {item.value}
                </Container>
              </DataList.ItemValue>
            </DataList.Item>
          ))}
          
      </DataList.Root>

      {/* Button to download the sample */}
      <HStack>
        <Button size="sm" onClick={handleDownload}>
          Download Sample
        </Button>
      </HStack>

    </PageContent>

  );
}

export default SamplePage;
